import e from'zod';const t=e.object({expiresIn:e.string(),accessToken:e.string()});export{t as JwtTokenSchema};